import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";

export default function useSessions(){

    const {id} = useParams()

    return useQuery({

        queryKey: ['design', id, 'sessions'],

        queryFn: () => API.get(`/design/courses/${id}/sessions`)
            .then(r => r.data),

        staleTime: 'Infinity',
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchOnMount: true,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    })
};
